<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Edit Doctor",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Edit Doctor",
            items: [
               {
                  text: "Doctors",
                  href: "/doctors",
               },
               {
                  text: "Edit Doctor",
                  active: true,
               },        
            ],

            doctor: {
               name: 'Dr. Prasad Varkey',
               dob: '1975-03-11',
               country_code: '91',
               mobile: '9110011001',
               email: 'prasad@gmail.com',
               address: '',
               qualification: 'MBBS, MD',
               current_hospital: 'ABCD Hospital',
               gender_id: 1,
               reg_no: '1234567890',
               reg_council: 'ABC Council',
               reg_date: '1995-01-20',
               account_no: '1234567890',
               account_name: 'Prasad Varkey',
               ifsc: 'SBI093445',
               upi_id: 'prasad@oksbi',
               username: 'prasad_varkey',
               image: 1,
               id_proof: 1,

            },
            specializations: [
               { id: 1 , title: 'Specialization 1' },
               { id: 2 , title: 'Specialization 2' }
            ],
            languages: [
               { id: 1 , title: 'Language 1' },
               { id: 2 , title: 'Language 2' },
               { id: 3 , title: 'Language 3' }
            ],

            
            specialization: '',
            language: '',

            certificates: [
               {id: 1, image: '@/assets/images/page-img/07.jpg'},
               {id: 2, image: '@/assets/images/page-img/08.jpg'},
            ],
            certificates_inputs: [
                  {value: null, preview_image: null, image: null}
            ],
            certificates_images: [],
            certificates_image_id: [],

         };
      },
      mounted() {
    
      },

      methods: {
         addSpecialization() {
            let text = event.target.options[event.target.options.selectedIndex].label;
            let index = event.target.options.selectedIndex;

            var exists = this.specializations.some(function(specialization) {
               return index === specialization.id;
            });

            if(!exists) {
               this.specializations.push({ id: index , title: text });
              }
            this.specialization = '';
         },

         removeSpecialization(index) {
              this.specializations.splice(index, 1);
         }, 

         addClinic() {
            let text = event.target.options[event.target.options.selectedIndex].label;
            let index = event.target.options.selectedIndex;

            var exists = this.clinics.some(function(clinic) {
               return index === clinic.id;
            });

            if(!exists) {
               this.clinics.push({ id: index , title: text });
              }
            this.clinic = '';
         },

         removeClinic(index) {
              this.clinics.splice(index, 1);
         }, 
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">

                  <!----- top button area starts---->
                  <div class="row mb-2">
                     <div class="col-12">
                        <router-link :to="{ name: 'doctors' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!-- <b-card header-class="bg-transparent border-light" class="border border-light"> -->
                     <form class="form-horizontal" role="form">
                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Personal Details</h4>
                           <div class="row">
                              <div class="form-group col-md-4">
                                 <label>Name <span class="text-danger">*</span></label>
                                 <input type="text" class="form-control" v-model="doctor.name" />
                              </div>                     
                                    
                              <!-- <div class="form-group col-md-4">
                                 <label>Mobile Number <span class="text-danger">*</span></label>
                                 <input type="text" class="form-control" v-model="doctor.mobile" />
                              </div> -->

                              <div class="form-group col-md-4">
                                 <label>Mobile Number <span class="text-danger">*</span></label>
                                 <b-input-group>
                                     <b-input-group-prepend>
                                          <select class="form-control" v-model="doctor.country_code">
                                             <option value="91">91</option>
                                             <option value="971">971</option>
                                          </select>
                                     </b-input-group-prepend>
                                     <b-form-input v-model="doctor.mobile"></b-form-input>
                                 </b-input-group>
                              </div>

                              <div class="form-group col-md-4">
                                 <label>Email ID </label>
                                 <input type="email" class="form-control" v-model="doctor.email" />
                              </div>

                              <div class="form-group col-md-4">
                                 <label>Date of Birth <span class="text-danger">*</span></label>
                                 <input type="date" class="form-control" v-model="doctor.dob" />
                              </div>

                              <div class="form-group col-md-4">
                                 <label>Gender <span class="text-danger">*</span></label>
                                 <select class="form-control"  v-model="doctor.gender_id">
                                    <option value="1">Male</option>
                                    <option value="2">Female</option>
                                    <option value="3">Others</option>
                                 </select>
                              </div>

                              <div class="form-group col-md-4">
                                 <label>Qualification <span class="text-danger">*</span></label>
                                 <input type="text" class="form-control" v-model="doctor.qualification"/>
                              </div>

                              <div class="form-group col-md-4">
                                 <label>Currently Practicing Hospital <span class="text-danger">*</span></label>
                                 <input type="text" class="form-control" v-model="doctor.current_hospital" />
                              </div>

                              <div class="form-group col-md-4">
                                 <label>Username <span class="text-danger">*</span></label>
                                 <input type="text" class="form-control"  v-model="doctor.username"/>
                              </div>

                              <div class="form-group col-md-4">
                                 <label>Address</label>
                                 <textarea rows="2" class="form-control" v-model="doctor.address"></textarea>
                              </div>                        
                              
                           </div>
                        </b-card>

                        <div class="row">
                           <div class="col-lg-6">                             
                              <b-card header-class="bg-transparent border-light" class="border border-light">
                                 <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Specializations</h4>

                                 <div class="row">
                                    <div class="form-group col-12">                                   
                                       <select class="form-control" @change="addSpecialization()" v-model="this.specialization">
                                          <option value="">Select</option>
                                          <option value="1">Specialization 1</option>
                                          <option value="2">Specialization 2</option>
                                          <option value="3">Specialization 3</option>
                                       </select>
                                    </div>

                                    <div class="col-12">
                                       <div class="input-tag" v-for="(specialization, index) in specializations" :key="index">
                                             <p>{{ specialization.title }}<span @click="removeSpecialization(index)" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                       </div>
                                    </div>

                                 </div>
                              </b-card>
                           </div>

                           <div class="col-lg-6">                             
                              <b-card header-class="bg-transparent border-light" class="border border-light">
                                 <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Languages</h4>

                                 <div class="row">
                                    <div class="form-group col-12">
                                       <select class="form-control" @change="addLanguage()" v-model="this.language">
                                          <option value="">Select</option>
                                          <option value="1">Language 1</option>
                                          <option value="2">Language 2</option>
                                          <option value="3">Language 3</option>
                                       </select>
                                    </div>

                                    <div class="col-12">
                                       <div class="input-tag" v-for="(language, index) in languages" :key="index">
                                             <p>{{ language.title }}<span @click="removeLanguage(index)" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                       </div>
                                    </div>
                                 </div>

                              </b-card>
                           </div>
                        </div>

                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Registration Details</h4>

                           <div class="row">
                              <div class="form-group col-md-4">
                                 <label>Reg. No. <span class="text-danger">*</span></label>
                                 <input type="text" class="form-control" v-model="doctor.reg_no" />
                              </div>   

                              <div class="form-group col-md-4">
                                 <label>Reg. Council <span class="text-danger">*</span></label>
                                 <input type="text" class="form-control" v-model="doctor.reg_council" />
                              </div>   

                              <div class="form-group col-md-4">
                                 <label>Reg. Date <span class="text-danger">*</span></label>
                                 <input type="date" class="form-control" v-model="doctor.reg_date" />
                              </div>      
                           </div>
                        </b-card>

                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Bank Details</h4>

                           <div class="row">
                              <div class="form-group col-md-6">
                                 <label>Account No.</label>
                                 <input type="text" class="form-control" v-model="doctor.account_no" />
                              </div>                              
                              <div class="form-group col-md-6">
                                 <label>Account Holder Name</label>
                                 <input type="text" class="form-control" v-model="doctor.account_name" />
                              </div>   
                              <div class="form-group col-md-6">
                                 <label>IFSC Code</label>
                                 <input type="text" class="form-control" v-model="doctor.ifsc" />
                              </div>   

                              <div class="form-group col-md-6">
                                 <label>UPI ID</label>
                                 <input type="text" class="form-control" v-model="doctor.upi_id" />
                              </div>
                           </div>
                        </b-card>

                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Image</h4>

                           <div class="row">
                              <div class="form-group col-md-6">
                                 
                                 <img class="avatar-md" src="@/assets/images/users/avatar-1.jpg" alt="">
                                 <input type="file" class="mt-2 form-control">
                                 <p class="small">(Leave this field empty if you don't want to change the image)</p>
                              </div>
                              
                           </div>
                        </b-card>

                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">ID Proof</h4>

                           <div class="row">
                              <div class="form-group col-md-6">
                                 <img class="avatar-md" src="@/assets/images/users/avatar-1.jpg" alt="">
                                 <input type="file" class="mt-2 form-control">
                                 <p class="small">(Leave this field empty if you don't want to change the image)</p>
                              </div>
                              
                           </div>
                        </b-card>

                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Certificates</h4>

                           <b-row v-for="(input, index) in certificates_inputs" :key="index">    
                              <b-col md="6" class="form-group">
                                 <div class="w-90">
                                    <b-form-file class=" form-control" accept=".jpg, .png, .jpeg"  v-model="input.value" @change="certificates_setFile($event, index)"></b-form-file>
                                 </div>

                                 <span class="ml-1 mt-2">
                                    <i class="fas fa-minus-circle text-danger" @click="certificates_remove(index)" v-show="index || ( !index && certificates_inputs.length > 1)"></i>
                                    <i class="fas fa-plus-circle text-success" @click="certificates_add()" v-show="index == certificates_inputs.length-1"></i>
                                 </span>
                              </b-col>
                              <b-col md="6">
                                 <img class="image-preview" v-bind:src="input.preview_image">
                              </b-col>
                           </b-row>
                        </b-card>


                        <div class="row mt-3">
                           <div class="12">
                              <button class="btn btn-primary me-2" type="submit">Save</button>
                              <router-link :to="{ name: 'doctors' }" class="btn btn-light">Cancel</router-link>
                           </div>
                        </div>
                     </form>
                  <!-- </b-card> -->
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
